import RsswYMMDReducer from "@store/Store/Components/RsswYMMD/RsswYMMDReducer";
import { combineReducers } from "redux";

const componentsReducers = {
    rsswYMMD: RsswYMMDReducer,
};

export type ComponentsReducers = typeof componentsReducers;

const componentsReducer = combineReducers(componentsReducers as any);
export default componentsReducer;
